import {Link, useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {ReduxStateInt, setSlider, setTfFilter, setXFilterValue} from "../../Reducer/GlobalReducer";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import styles from './XFilterPath.module.css'

export default function XFilterPath()
{
    const path = useLocation()
    const tfFilter = useSelector((state:ReduxStateInt)  => {return state.tarifFilter} )
    const xfFilter = useSelector((state:ReduxStateInt)  => {return state.xFilter} )

    const tarifXFilterData = useRef()
    const [ldrTarifXFilter, rsTarifXFilter, exTarifXFilter] = useApiQuery("/ref/tarif/xfilter","get",tarifXFilterData)

    const [title,setTitle] = useState("Выбранные тарифы")
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const rxObserve = useSelector((state: ReduxStateInt) => {
        return state.rxObserve
    })




    useEffect(()=>{
        //console.log("load x")
        loadXTarif()
    },[path.pathname])

    const loadXTarif = () =>{
        exTarifXFilter().then((e)=>{
            if(e?.success && Array.isArray(e?.payload))
            {
                const valReg = path?.pathname?.match(/(?<=xfilter\/).*$/)
                if(valReg)
                {
                    const x = e?.payload?.filter((item)=> item?.val === valReg[0])
                    if(x?.length && x[0]?.desc) setTitle( x[0]?.desc)
                    applyXFilter()
                    console.log("xFilter",x)

                }
                return
            }
            moveHome()

        }).catch((e)=>{
            moveHome()
        })
    }

    const moveHome = () =>{
        //dispatch(sendActionMessage("hello"))
        dispatch(setSlider({sliderMode:0}));
        dispatch(setTfFilter({...tfFilter,active: false}))
        dispatch(setXFilterValue({...xfFilter,active: false,val:""}))
        rxObserve.next({
            message :"xFilter-reset"
        })
        rxObserve.next({
            message :"tFilter-reset"
        })

        navigate('/')

    }


    const applyXFilter = ()=>{
        if(path?.pathname)
        {
            const valReg = path?.pathname?.match(/(?<=xfilter\/).*$/)
            if(valReg)
            {
                //console.log("send message", valReg[0])
                rxObserve.next({
                    message:"xFilter-make",
                    data: {val:valReg[0]}
                })
                dispatch(setXFilterValue({
                    val: valReg[0],
                    active: true
                }))

            }
        }
    }

    return (
        <div className={styles.mainCont}>
            <div className={[styles.btnCont].join(' ')}>
                <Link to={"/"} className={styles.link}>
                    <div className={styles.btnSelect}
                         onClick={()=>{
                            moveHome()
                         }}
                    >Все тарифы</div>

                </Link>
            </div>
            <div className={styles.title}>{title}</div>


        </div>
    )
}